<template>
  <div class="writeInfoWrapper">
    <el-form
      ref="insuredForm"
      :rules="insuredsFormRules"
      :model="insuredsForm"
      label-position="left"
      label-width="110px"
    >
      <div class="insuredItem" v-for="(item, index) in insuredsForm.insuredList" :key="index">
        <div class="insuredItem-title">
          <span :style="{ color: themeObj.color }">被保人{{ index + 1 }}</span>
          <div class="addreduce">
            <div class="add" @click="addInsured">
              <m-svg name="addInsure" style="height: 18px; width: 18px; margin-right: 6px" /> 添加被保人
            </div>
            <div class="reduce" @click="reduceInsured(index)">
              <m-svg name="reduceInsure" style="height: 18px; width: 18px; margin-right: 6px" /> 移除被保人
            </div>
          </div>
        </div>
        <div class="insuredDescInfo">
          <el-form-item label="方案：" :prop="'insuredList.' + index + '.planId'">
            <el-radio-group v-model="item.planId">
              <el-radio-button :label="1">标准方案</el-radio-button>
              <el-radio-button :label="2">豪华方案</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="费率：">
            <span>360.00 元/人</span>
          </el-form-item>
          <el-form-item label="姓名：" :prop="'insuredList.' + index + '.name'">
            <el-input v-model="item.name" style="width: 290px" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="证件类型：" :prop="'insuredList.' + index + '.idCardType'">
            <el-select clearable v-model="item.idCardType" placeholder="证件类型" style="width: 290px">
              <el-option
                :label="item.dicItemName"
                :value="item.dicItemCode"
                v-for="(item, index) in cardTypeDic"
                :key="index + 'dicList1'"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码：" :prop="'insuredList.' + index + '.idCardNo'">
            <el-input v-model="item.idCardNo" style="width: 290px" placeholder="请输入证件号码"></el-input>
          </el-form-item>
          <el-form-item label="性别：" :prop="'insuredList.' + index + '.gender'">
            <el-radio-group v-model="item.gender">
              <el-radio :label="'01'">男</el-radio>
              <el-radio :label="'02'">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年龄：" :prop="'insuredList.' + index + '.age'">
            <el-input v-model="item.age" style="width: 290px" placeholder="请输入年龄"></el-input>
          </el-form-item>
          <el-form-item label="与员工关系：" :prop="'insuredList.' + index + '.relaWithStaff'">
            <el-select clearable v-model="item.relaWithStaff" placeholder="请选择与员工关系" style="width: 290px">
              <el-option
                :label="item.dicItemName"
                :value="item.dicItemCode"
                v-for="(item, index) in relaWithStaffDic"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号：" :prop="'insuredList.' + index + '.phoneNo'">
            <el-input v-model="item.phoneNo" style="width: 290px" placeholder="请输入手机号码"></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="btngroup">
      <el-button type="primary" plain>取消</el-button>
      <el-button type="primary" @click="next">下一步</el-button>
    </div>
  </div>
</template>
<script>
import { myMixin } from '@/mixins';
export default {
  mixins: [myMixin],
  computed: {
    themeObj() {
      return this.$store.getters['layoutStore/getThemeObj'];
    },
  },
  data() {
    return {
      dicArr: ['gen.identityType', 'gcbs.rela.with.staff'],
      emptyInsured: {
        planId: '',
        rate: '',
        name: '',
        idCardType: '',
        idCardNo: '',
        gender: '',
        age: '',
        relaWithStaff: '',
        phoneNo: '',
      },
      insuredsForm: {
        insuredList: [],
      },
      emptyRlue: {
        planId: [{ required: true, message: '请选择方案', trigger: 'change' }],
        name: [{ required: true, message: '请填写姓名', trigger: 'blur' }],
        idCardType: [{ required: true, message: '请选择证件类型', trigger: 'change' }],
        idCardNo: [{ required: true, message: '请填写证件号码', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        age: [{ required: true, message: '请填写年龄', trigger: 'blur' }],
        relaWithStaff: [{ required: true, message: '请选择与员工关系', trigger: 'change' }],
        phoneNo: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
      },
      insuredsFormRules: {
        insuredList: [],
      },
      cardTypeDic: [],
      relaWithStaffDic: [],
    };
  },
  methods: {
    initData() {
      this.insuredsForm.insuredList.push(_.cloneDeep(this.emptyInsured));
      this.insuredsFormRules.insuredList.push(_.cloneDeep(this.emptyRlue));
    },
    // 获取字典
    async getDics() {
      this.cardTypeDic = this.$store.state.dicMap['gen.identityType']
        ? this.$store.state.dicMap['gen.identityType']
        : await getDicList('gen.identityType');
      this.relaWithStaffDic = this.$store.state.dicMap['gcbs.rela.with.staff']
        ? this.$store.state.dicMap['gcbs.rela.with.staff']
        : await getDicList('gcbs.rela.with.staff');
    },
    addInsured() {
      this.insuredsForm.insuredList.push(_.cloneDeep(this.emptyInsured));
      this.insuredsFormRules.insuredList.push(_.cloneDeep(this.emptyRlue));
    },
    reduceInsured(index) {
      this.insuredsForm.insuredList.splice(index, 1);
      this.insuredsFormRules.insuredList.splice(index, 1);
    },
    next() {
      let params = this.$route.params.planId;
      this.$router.push({
        path: `/plan/${params}/pay`,
      });
    },
  },
  async created() {
    this.initData();
    await this.getDics();
  },
};
</script>
<style lang="less" scoped>
.insuredItem {
  .insuredItem-title {
    display: flex;
    .addreduce {
      margin-left: auto;
      display: flex;
      .add,
      .reduce {
        line-height: 20px;
        display: flex;
        align-items: center;
        margin-right: 22px;
        cursor: pointer;
      }
    }
  }
  .insuredDescInfo {
    padding: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    border: 1px solid #dcdce1;
  }
}
</style>